import Icon from '../components/Icon.vue'

Icon.register({
  female: {
    width: 256,
    height: 512,
    paths: [
      {
        d: 'M128 0c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM247.3 354.2c3.8 15.2-7.7 29.8-23.3 29.8h-56v104c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24v-104h-56c-15.6 0-27.1-14.7-23.3-29.8l48-192c2.5-10 12.9-18.2 23.3-18.2h11.4c23.7 10.9 50.6 10.4 73.3 0h11.4c10.3 0 20.8 8.1 23.3 18.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/female.js
// module id = 1325
// module chunks = 0